<template>
  <v-dialog v-model="update.en" scrollable persistent max-width="100%" width="1000">
    <v-card v-if="update.board" color="white" elevation="0" width="100" height="auto">
      <v-card-title class="w-100">
        <v-spacer></v-spacer>
        <h4>ویرایش برد</h4>
        <v-spacer></v-spacer>
        <v-btn @click="closeCreate" text rounded>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-divider class="mx-5 my-5"></v-divider>
        <v-row>
          <v-col>
            <v-text-field
                outlined
                label="نام برد"
                v-model="update.board.name"
                :error-messages="getErrorMessage('name')"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
                outlined
                label="کد"
                v-model="update.board.code"
                :error-messages="getErrorMessage('code')"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6" sm="6" lg="6" class="text-center">
            <h3>رله ها :</h3>
            <div class=" pt-5">
              <v-list style="height:500px;max-height: 90%" class="overflow-y-auto">
                <v-row style="padding: 0; margin: 0;" v-for="(device, index) in update.board.relays" :key="index">
                  <v-col cols="1">
                    <div class="mt-3 text-center" style="font-size: 8px;display: grid">{{ index + 1 }}.</div>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                        dense hide-details filled
                        v-model="update.board.relays[index]['name']"
                        placeholder="نام نمایشی "
                        @keyup="addNewRow(index)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1">
                    <div class="mt-3 text-center" style="font-size: 30px;color: red">:</div>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                        dense hide-details filled
                        v-model="update.board.relays[index]['value']"
                        placeholder="نام ارسالی از برد"
                        @keyup="addNewRow(index)"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-list>
            </div>
          </v-col>
          <v-col cols="12" md="6" sm="6" lg="6" class="text-center">
            <h3>ست پوینت ها :</h3>
            <div class=" pt-5">
              <v-list style="height:500px;max-height: 90%" class="overflow-y-auto">
                <v-row style="padding: 0; margin: 0;" v-for="(device, index) in update.board.sets" :key="index">
                  <v-col cols="1">
                    <div class="mt-3 text-center" style="font-size: 8px;display: grid">{{ index + 1 }}.</div>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                        dense hide-details filled
                        v-model="update.board.sets[index]['name']"
                        placeholder="کد"
                        @keyup="addNewSetRow(index)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1">
                    <div class="mt-3 text-center" style="font-size: 30px;color: red">:</div>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                        dense hide-details filled
                        v-model="update.board.sets[index]['value']"
                        placeholder="Set Point"
                        @keyup="addNewSetRow(index)"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-list>
            </div>
          </v-col>
        </v-row>

        <v-sheet class="container" style="border: 1px rgba(0,0,0,0.2) solid" rounded>
          <div class="row">
            <h3 class="mr-5 my-auto">
              توضیحات
            </h3>
            <v-spacer></v-spacer>
            <div>
              <v-btn icon @click="des_show=!des_show">
                <v-icon v-if="des_show">
                  mdi-arrow-up-drop-circle
                </v-icon>
                <v-icon v-else>
                  mdi-arrow-down-drop-circle
                </v-icon>
              </v-btn>
            </div>
          </div>
          <v-textarea
              v-if="des_show" dense
              hide-details
              class="mt-5"
              v-model="update.board.descriptions"
              placeholder="افزودن توضیحات برد در صورت نیاز..."
          ></v-textarea>
        </v-sheet>
      </v-card-text>

      <v-card-actions>
        <v-col cols="12">
          <v-btn block large class="elevation-0 text-bold" color="success" @click="sendBoard" :loading="btn_loading">
            ثبت تغییرات
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style>
.gauge-title{
  font-size: 2em;
}
</style>

<script>
import axios from "axios";

export default {
  name: "BoardUpdate",
  props: ["update"],

  data: () => ({
    key: localStorage.getItem('key'),
    errors: {},
    btn_loading: false,
    des_show: false,
  }),
  watch: {
    update: {
      immediate: true,
      handler() {
        if (this.update.en) {
          if (this.update.board.relays.length === 0 || !this.update.board.relays) {
            this.update.board.relays.push({name: '', value: ''});
          }else{
            if(this.update.board.relays[this.update.board.relays.length-1].name){
              this.update.board.relays.push({name: '', value: ''});
            }
          }
          if (this.update.board.sets === null || this.update.board.sets.length === 0) {
            this.update.board.sets.push({name: '', value: ''});
          }else{
            if(this.update.board.sets[this.update.board.sets.length-1].name){
              this.update.board.sets.push({name: '', value: ''});
            }
          }
        }
      },
    },
  },
  methods: {
    addNewRow(index) {
      if(this.update.board.relays.length === index+1){
        if(this.update.board.relays[index].name && this.update.board.relays[index].value){
          this.update.board.relays.push({name:null, value:null})
        }
      }else{
        if(!this.update.board.relays[index].name && !this.update.board.relays[index].value){
          if(!this.update.board.relays[index].name && !this.update.board.relays[index].value){
            this.$delete(this.update.board.relays, index);
          }else{
            this.update.board.relays.pop();
          }
        }
      }
    },
    addNewSetRow(index) {
      if(this.update.board.sets.length === index+1){
        if(this.update.board.sets[index].name && this.update.board.sets[index].value){
          this.update.board.sets.push({name:null, value:null})
        }
      }else{
        if(!this.update.board.sets[index].name && !this.update.board.sets[index].value){
          if(!this.update.board.sets[index].name && !this.update.board.sets[index].value){
            this.$delete(this.update.board.sets, index);
          }else{
            this.update.board.sets.pop();
          }
        }
      }
    },

    getErrorMessage(field) {
      if(this.errors){
        return this.errors[field] ? this.errors[field][0] : false;
      }
      return false
    },

    async sendBoard() {
      if (this.update.board.relays.length > 1) {
        this.btn_loading = true;
        this.update.board.relays.pop();
        this.update.board.sets.pop();
        try {
          await axios
              .put(`${this.BACKEND_LINK}/api/devices-data/detail/${this.update.board.id}`, {
                relays: this.update.board.relays,
                sets: this.update.board.sets,
                name: this.update.board.name,
                code: this.update.board.code,
                devices: this.update.board.devices,
                descriptions: this.update.board.descriptions
              }, {
                headers: {'Authorization': `Token ${this.key}`}
              })
              .then(() => {
                this.$snotify.success('اطلاعات با موفقیت ثبت شد.');
                this.closeCreate()
              })
              .catch((errors) => {
                if (errors.response.data) {
                  this.errors = errors.response.data
                }
                this.$snotify.error(`خطا در ثبت اطلاعات `);
                this.update.board.relays.push({name: null, value: null});
                this.update.board.sets.push({name: null, value: null});
              })
              .finally(() => {
                this.btn_loading = false;
              })
        } catch (error) {
          this.$snotify.error(`خطا در ثبت اطلاعات : ${error}`);
          this.btn_loading = false;
          this.update.board.relays.push({name: null, value: null});
          this.update.board.sets.push({name: null, value: null});
        }
      } else {
        this.$snotify.error(`حداقل یک سنسور اضافه کنید`);
      }
    },

    closeCreate() {
      this.showCreate = false;
      this.$emit('close');
    },
  },
};
</script>
